import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PerformanceTeamPulsePage from "@/pages/admin/PerformanceTeamPulsePage";

export const Route = createFileRoute("/_admin/admin/performance/team-pulse")({
  head: () => pageHead("Admin · Performance · Team Pulse", "AKIVA admin · performance · team pulse portal.", "/admin/performance/team-pulse", true),
  component: PerformanceTeamPulsePage,
});
